<template>
    <v-container fluid>
        <v-card>
            <v-card-title>
                <v-row 
                    no-gutters 
                    align="start" 
                    justify="space-between">
                    <v-col sm="auto">
                        <div class="title">
                            Externo | Mis Documentos
                        </div>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <expansion-panels-documentos
                    :tipos-documentos="tiposDocumentos"
                    :loading="loading"
                />
            </v-card-text>
        </v-card>
        <v-snackbar
            key="snackbar_documentosexterno"
            v-model="snackbarError"
            :bottom="true"
            :multi-line="true"
            color="error"
        >
            {{ textoError }}
            <v-btn 
                dark 
                text 
                @click="snackbarError = false">
                Cerrar
            </v-btn>
        </v-snackbar>
    </v-container>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { getTiposDocumentos } from "@/api";

export default {
  name: "DocumentosExterno",
  components: {
    ExpansionPanelsDocumentos: () =>
      import("../../components/molecules/ExpansionPanelsDocumentos")
  },
  props: {},
  data () {
    return {
      tiposDocumentos: [],
      loading: true,
      snackbarError: false,
      textoError: ""
    };
  },
  computed: {},
  mounted () {
    this.getTiposDocumentos_();
  },
  methods: {
    async getTiposDocumentos_ () {
      var self = this;
      self.loading = true;

      try {
        let response = await getTiposDocumentos();

        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "True") {
              self.tiposDocumentos = response.data.data;
              self.snackbarError = false;
              self.textoError = "";
            }
          } else {
            self.snackbarError = true;
            self.textoError = response.data.message;
          }
        } else {
          self.snackbarError = true;
          self.textoError = "Error de red";
        }

        self.loading = false;
      } catch (e) {
        self.loading = false;

        self.snackbarError = true;
        self.textoError = e;
      }
    }
  }
};
</script>
